import { gql } from "@apollo/client";

export const SUBMIT_FEEDBACK = gql`
  mutation SUBMIT_FEEDBACK($message: String!, $subject: String!) {
    submitFeedback(message: $message, subject: $subject) {
      message
    }
  }
`;
